import React from 'react';
import { ExpandableListItem } from './ExpandableListItem';
import { SectionTitle } from '@components/common/section-title';
import { Theme } from '@theme/base';
import { SectionTitleSizes } from '@styles/layout';
import { ExpandableListGroupItem } from '@model/common';

export interface ExpandableListWrapperProps {
  items: Array<ExpandableListGroupItem>;
  heading?: string;
  titleSize?: SectionTitleSizes;
  testId?: string;
  theme?: Theme;
  iconSize?: number;
}

export default function ExpandableListWrapper(props: ExpandableListWrapperProps) {
  const { items, heading, titleSize, testId } = props;
  return (
    <div data-testid={testId}>
      {heading && <SectionTitle heading={heading} size={titleSize} />}
      <div>
        <ExpandableListItem items={items} />
      </div>
    </div>
  );
}
